/** Keep provenance visible while excluding superseded AI values from current scores. */
export function currentAssessmentResponse<T extends { response: any; score?: number | null }>(
  answer: T
): T {
  if (answer.response?.assessment?.origin !== 'ai' || !answer.response.assessment.stale)
    return answer;
  return {
    ...answer,
    score: answer.score === null ? null : 0,
    response: { assessment: answer.response.assessment },
  };
}

/** An explicit negative or zero is still an answer; superseded AI values are not. */
export function hasCurrentAssessmentAnswer(answer?: { response: any } | null): boolean {
  const response = answer ? currentAssessmentResponse(answer).response : null;
  return (
    typeof response?.booleanValue === 'boolean' ||
    Array.isArray(response?.selectedOptions) ||
    (typeof response?.numericValue === 'number' && Number.isFinite(response.numericValue)) ||
    (typeof response?.textValue === 'string' && response.textValue.trim().length > 0) ||
    ['low', 'medium', 'high'].includes(response?.impactLevel)
  );
}

export function currentAssessmentQuestion<
  T extends { responses?: Array<{ response: any; score?: number | null }> },
>(question: T): T {
  return { ...question, responses: question.responses?.map(currentAssessmentResponse) };
}
